__turbopack_context__.v({
  "root": "AuthInvalidUser-module-scss-module__GhbtEG__root",
});
